var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"color":_vm.color,"size":_vm.size}},[_vm._v("mdi-history")])}
var staticRenderFns = []

export { render, staticRenderFns }